import React from "react";
import { Link } from "react-router-dom";
import { formatPrice, siteConfig } from "../Datas/productData";
import "../css/delivery.scss";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="policy-page delivery">
      <header className="policy-hero">
        <p className="policy-eyebrow">Customer care</p>
        <h1>Shipping &amp; delivery</h1>
        <p>
          A simple guide to dispatch, delivery estimates, tracking, and the
          journey from our studio to your door.
        </p>
      </header>

      <div className="policy-layout">
        <nav className="policy-nav" aria-label="Customer care pages">
          <p>How can we help?</p>
          <Link className="is-active" to="/shipping" aria-current="page">
            Shipping &amp; delivery <span aria-hidden="true">→</span>
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns &amp; refunds <span aria-hidden="true">→</span>
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact us <span aria-hidden="true">→</span>
          </Link>
        </nav>

        <article className="policy-content">
          <section className="policy-intro" aria-labelledby="delivery-overview">
            <p className="policy-eyebrow">At a glance</p>
            <h2 id="delivery-overview">Your order, carefully on its way.</h2>
            <p>
              Orders are prepared Monday through Friday, excluding public
              holidays. Once a parcel leaves our studio, you will receive a
              dispatch confirmation with its tracking details.
            </p>
          </section>

          <section className="policy-cards" aria-label="Delivery highlights">
            <div>
              <span>01</span>
              <h3>1–2 days</h3>
              <p>Typical studio processing before a parcel is collected.</p>
            </div>
            <div>
              <span>02</span>
              <h3>Tracked</h3>
              <p>A tracking link is emailed after every dispatch.</p>
            </div>
            <div>
              <span>03</span>
              <h3>{formatPrice(siteConfig.shipping.standardRate)}</h3>
              <p>Flat-rate tracked shipping for every supported destination.</p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="delivery-options">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="delivery-options">Delivery options</h2>
            </div>
            <p>
              Estimates begin after dispatch and are shown in business days.
              Remote areas and seasonal peaks may require additional time.
            </p>

            <div
              className="policy-table-wrap"
              tabIndex="0"
              role="region"
              aria-label="Shipping fees table; scroll horizontally for more columns"
            >
              <table>
                <caption className="sr-only">Illustrative shipping estimates and fees</caption>
                <thead>
                  <tr>
                    <th scope="col">Destination</th>
                    <th scope="col">Service</th>
                    <th scope="col">Estimate</th>
                    <th scope="col">From</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Local metro</th>
                    <td>Standard tracked</td>
                    <td>2–4 days</td>
                    <td>{formatPrice(siteConfig.shipping.standardRate)}</td>
                  </tr>
                  <tr>
                    <th scope="row">Regional</th>
                    <td>International tracked</td>
                    <td>5–9 days</td>
                    <td>{formatPrice(siteConfig.shipping.standardRate)}</td>
                  </tr>
                  <tr>
                    <th scope="row">Rest of world</th>
                    <td>International tracked</td>
                    <td>7–14 days</td>
                    <td>{formatPrice(siteConfig.shipping.standardRate)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="tracking-orders">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="tracking-orders">Tracking your order</h2>
            </div>
            <p>
              Tracking can take up to 24 hours to update after collection. If
              your link remains inactive after that window, contact our team
              with the email used at checkout and your order number.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="customs-duties">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="customs-duties">Duties, taxes &amp; delivery changes</h2>
            </div>
            <p>
              International duties and local taxes are not included unless a
              checkout clearly says otherwise. They are normally collected by
              the destination authority or courier and remain the recipient’s
              responsibility.
            </p>
            <p>
              Please check your address before completing checkout. We cannot
              guarantee changes after an order enters processing, but we will
              always try to help before dispatch.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="shipping-help">
            <div>
              <p className="policy-eyebrow">Still need a hand?</p>
              <h2 id="shipping-help">We’ll help you find your parcel.</h2>
            </div>
            <a href={`mailto:${siteConfig.contact.email}`}>
              Email customer care <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Delivery;
